

import { createSlice } from '@reduxjs/toolkit';

const filterBooks=createSlice({
    name:"filterbook",
    initialState:{
        search:"",
        sort:"All"
    },
    reducers:{
        searching:(state, action)=>{
            state.search = (action.payload);
        },
        filtering:(state, action)=>{
            state.sort = (action.payload);
        },
    }


});


export const {searching,filtering}=filterBooks.actions;
export default filterBooks.reducer;